// Hand-rolled and scoped to the shadow root TourBuilder mounts into - not
// Tailwind/shadcn (that's the admin app's stack) and not a plain CSS import,
// which rspack would inline into document.head where it couldn't reach
// anything inside a shadow tree. `all: initial` on the root undoes whatever
// the host page's global styles would otherwise inherit in (color,
// font-family, line-height, etc. cross the shadow boundary by default).
export const TOUR_BUILDER_STYLES = `
.bizzey-tb-root {
  all: initial;
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  pointer-events: none;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #1f2328;
}

.bizzey-tb-root * {
  box-sizing: border-box;
}

.bizzey-tb-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.08);
  pointer-events: auto;
}

.bizzey-tb-bar__header {
  display: flex;
  align-items: center;
  padding: 14px 20px 0;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.bizzey-tb-bar__tabs {
  display: flex;
  gap: 24px;
}

.bizzey-tb-tab {
  padding: 0 0 12px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
  color: #6b7280;
  cursor: pointer;
}

.bizzey-tb-tab--active {
  color: #111827;
  border-bottom-color: #f2542d;
}

.bizzey-tb-bar__body {
  padding: 20px;
  overflow-x: auto;
  flex-shrink: 0;
}

.bizzey-tb-bar__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.bizzey-tb-bar__actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.bizzey-tb-footer-button {
  padding: 0;
  border: none;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}

.bizzey-tb-footer-button--link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #2563eb;
}

.bizzey-tb-footer-button--ghost {
  color: #374151;
}

.bizzey-tb-footer-button--primary {
  background: #111827;
  color: #ffffff;
  padding: 10px 22px;
  border-radius: 999px;
}

.bizzey-tb-picker-bar {
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
}

.bizzey-tb-picker-bar__hide {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border: none;
  border-radius: 6px;
  background: #f3f4f6;
  color: #374151;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}

.bizzey-tb-picker-bar__divider {
  width: 1px;
  height: 20px;
  background: #e5e7eb;
  flex-shrink: 0;
}

.bizzey-tb-picker-bar__selector {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  color: #4b5563;
}

.bizzey-tb-picker-bar__cancel {
  padding: 7px 16px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #ffffff;
  color: #374151;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
}

.bizzey-tb-picker-bar__cancel:hover {
  background: #f9fafb;
}

.bizzey-tb-step-strip {
  display: flex;
  align-items: center;
  gap: 10px;
}

.bizzey-tb-step-connector {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}

.bizzey-tb-step-card {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 205px;
  max-width: 310px;
  height: 150px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
}

.bizzey-tb-step-card:hover {
  border-color: #d1d5db;
}

.bizzey-tb-step-card--dragging {
  opacity: 0.6;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
}

.bizzey-tb-step-card__text {
  flex: 1;
  min-width: 0;
}

.bizzey-tb-step-card__title {
  font-weight: 500;
  font-size: 14px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bizzey-tb-step-card__description {
  margin-top: 4px;
  font-size: 13px;
  color: #4b5563;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.bizzey-tb-step-card__controls {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.bizzey-tb-step-card:hover .bizzey-tb-step-card__controls,
.bizzey-tb-step-card:focus-within .bizzey-tb-step-card__controls {
  opacity: 1;
}

.bizzey-tb-step-card__handle,
.bizzey-tb-step-card__delete {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.bizzey-tb-step-card__handle {
  border: none;
  background: #f3f4f6;
  color: #6b7280;
  cursor: grab;
  touch-action: none;
}

.bizzey-tb-step-card__handle:hover {
  color: #374151;
}

.bizzey-tb-step-card__delete {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #dc2626;
}

.bizzey-tb-step-card__delete:hover {
  background: #fef2f2;
  border-color: #fecaca;
}

.bizzey-tb-add-step {
  flex-shrink: 0;
  min-width: 205px;
  height: 150px;
  border-radius: 14px;
  border: none;
  background: #f3f4f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}

.bizzey-tb-add-step__default {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #374151;
}

.bizzey-tb-add-step:hover .bizzey-tb-add-step__default {
  display: none;
}

.bizzey-tb-add-step__options {
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.bizzey-tb-add-step:hover .bizzey-tb-add-step__options {
  display: flex;
}

.bizzey-tb-add-step__options-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bizzey-tb-add-step__option {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: 1.5px solid transparent;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111827;
  cursor: pointer;
}

.bizzey-tb-add-step__option--hover {
  border-color: #ea580c;
  color: #ea580c;
}

.bizzey-tb-add-step__label {
  min-height: 16px;
  font-size: 13px;
  font-weight: 600;
  color: #ea580c;
}

.bizzey-tb-settings {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.bizzey-tb-settings__row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.bizzey-tb-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-family: inherit;
}

.bizzey-tb-editor-frame {
  display: block;
  width: 100%;
  height: 120px;
  margin-top: 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
}

.bizzey-tb-button {
  padding: 7px 14px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid transparent;
}

.bizzey-tb-button--ghost {
  background: transparent;
  border-color: #d1d5db;
  color: #374151;
}

.bizzey-tb-button--primary {
  background: #1a73e8;
  color: #ffffff;
}

.bizzey-tb-button--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bizzey-tb-icon-button {
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 4px;
}

.bizzey-tb-icon-button:hover {
  background: rgba(0, 0, 0, 0.06);
}

.bizzey-tb-link-button {
  border: none;
  background: transparent;
  color: #1a73e8;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
}

.bizzey-tb-popover {
  z-index: 2;
  width: 300px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  padding: 14px;
  pointer-events: auto;
}

.bizzey-tb-popover__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 10px;
}

.bizzey-tb-popover__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.bizzey-tb-field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  font-size: 12px;
}

.bizzey-tb-field-label {
  color: #6b7280;
  flex-shrink: 0;
}

.bizzey-tb-selector {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #f3f4f6;
  padding: 4px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  font: inherit;
  font-size: 12px;
  color: #374151;
}

.bizzey-tb-selector:focus {
  outline: none;
  border-color: #1a73e8;
  background: #ffffff;
}

.bizzey-tb-side-picker {
  display: flex;
  gap: 4px;
}

.bizzey-tb-side-option {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  background: transparent;
  color: #374151;
  font-size: 11px;
  cursor: pointer;
  text-transform: capitalize;
}

.bizzey-tb-side-option--active {
  background: #1a73e8;
  border-color: #1a73e8;
  color: #ffffff;
}
`;
